module.exports = __webpack_public_path__ + "img/ddb1bd4.jpg";